<template>
  <div class="images-container">
    <b-button class="action-button" @click="upload()" size="sm" variant="success">Add Image</b-button>
    <input type="file" class="hide-me-seymour" accept="image/*" ref="fileupload" @change="fileChange($event)" />
    <draggable
      handle=".handle"
      :list="images"
      @end="reorderImage"
      v-bind="dragOptions">
      <transition-group>
          <div v-for="img in images" :key="img.order">
            <div class="row image-row handle">
              <div class="col col-md-2">
                <img class="handle" :src="img.url" :alt="img.title" />
              </div>
              <div class="col">
                <input type="text" v-model="img.title" placeholder="Describe this image" />
              </div>
              <div class="col col-md-1 icons-col">
                <b-icon-arrows-expand class="handle" />
                <b-icon-trash @click="trash(img.url)" />
              </div>
            </div>
          </div>
      </transition-group>
    </draggable>
    <p>Changes to your images won't be saved until you hit the Save button below.</p>
  </div>
</template>

<script>
import axios from 'axios';
import draggable from 'vuedraggable';

const server = process.env.VUE_APP_API_URL;

export default {
  props: {
    listingId: String,
    setImages: Function,
    images: Array,
  },
  components: {
    draggable,
  },
  data() {
    return {
      // imagesArray: [],
      options: {
        url: `${server}/api/listing/${this.listingId}/upload`,
        paramName: 'file',
      },
      dragging: false,
      toDelete: null,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    trash(id) {
      console.log(`trashing ${id}`);
      this.toDelete = id;
      this.showDeleteModal();
    },
    upload() {
      this.$refs.fileupload.click();
    },
    reorderImage() {
      console.log(this.images);
    },
    showDeleteModal() {
      this.boxTwo = '';
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this image? This cannot be undone once you save.', {
        title: 'Delete Image',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DELETE',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then((value) => {
          if (value) {
            this.setImages(this.images.filter((img) => img.url !== this.toDelete));
          }
          this.toDelete = null;
        });
    },
    async fileChange(evt) {
      console.log({ files: evt.target.files[0] });
      const formData = new FormData();
      formData.append('file', evt.target.files[0]);
      const imageMeta = await axios.post(this.options.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const newurl = imageMeta.data.url;
      this.setImages([...this.images, {
        url: newurl,
        title: '',
        order: 9999,
      }]);
    },
    mounted() {
      this.$nextTick(() => {
        console.log('meep', this.images);
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.hide-me-seymour {
  position: relative;
  top: -20000px;
}

.images-container {
  position: relative;
}

.action-button {
  position: absolute;
  top: -60px;
  right: 0px;
}

.image-row {
  background: white;
  border-radius: 5px;
  border: 1px solid #ddd;
  padding: 20px;
  margin-bottom: 20px;
  margin-left: 0px;
  margin-right: 0px;
  img {
    height: 90px;
    border-radius: 3px;
  }
  input {
    padding: 8px 10px;
    border-radius: 5px;
    background: #fafafa;
    outline: none !important;
    border: 1px solid #ccc;
    width: 95%;
  }
  .col {
    align-self: center;
  }
  .icons-col svg:first-child {
    margin-right: 20px;
  }
  .icons-col .bi-trash {
    cursor: pointer;
  }
}

.handle {
  cursor: ns-resize;
}
</style>
